import {useAuthStore} from "~/stores/auth.ts";

export default defineNuxtRouteMiddleware((to, from) => {
    const authStore = useAuthStore();

    // if (!authStore.isLoggedIn) {
    //     return navigateTo('/login');
    // }

})